import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeBottom24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconEdgeBottom24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.125 7.875a1 1 0 1 0 2 0 1 1 0 0 0-2 0m0 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-2 9.25a.75.75 0 0 0 0-1.5h-10a.75.75 0 0 0 0 1.5zm-13-8.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2m15 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-15 1.32a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0-8.32a1 1 0 1 1 0-2 1 1 0 0 1 0 2m11-5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-3 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-5-1a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeBottom24);
